module.exports = __webpack_public_path__ + "static/media/make-your-mark-long@2x.0617e293.png";